// meta-tags/index.js
const anyStringMatches = (arr, val) => arr.some(arrVal => val.includes(arrVal));

const removeDateFromURL = [
  'flight-tracker',
  'flight-details',
  'flight-alerts',
];

const removeDateFromLongerURL = [
  'departing-arriving',
];

const parsePathname = (pathname) => {
  let spliceLength = 0;
  if (anyStringMatches(removeDateFromURL, pathname)) {
    spliceLength = 3;
  } else if (anyStringMatches(removeDateFromLongerURL, pathname)) {
    spliceLength = 4;
  }

  return (!spliceLength > 0) ? pathname :
    `/${pathname.split('/').splice(1, spliceLength).join('/')}`;
};

export const canonicalPathname = pathname => parsePathname(pathname);

export const addMetaCanonical = (metaTags, pathname) => {
  if (!metaTags || !pathname) {
    return metaTags;
  }

  const { meta = [] } = metaTags;
  const canonical = `https://www.flightstats.com/v2${canonicalPathname(pathname)}`;

  meta.push({ property: 'og:url', content: canonical });

  return {
    ...metaTags,
    canonical,
    link: [{ rel: 'canonical', href: canonical }],
    meta,
  };
};



// WEBPACK FOOTER //
// ./shared/lib/meta-tags/index.js